import type { TabId } from './store/tabId';

const TABS: readonly TabId[] = ['steps', 'actions', 'network', 'events'];

function isTabId(s: string): s is TabId {
  return (TABS as readonly string[]).includes(s);
}

export type SessionViewerUrlBootstrap = {
  initialTimeMs?: number;
  initialTab?: TabId;
  selectedItemId?: string | null;
  initialFocus?: 'error' | 'none';
};

/**
 * Parse viewer deep-link query params. Safe to call without `window` during SSR tests (pass `''`).
 *
 * Supported keys: `t` | `time` (ms), `tab`, `sel` | `id`, `focus=error`
 */
export function bootstrapSessionFromUrl(search: string = typeof window !== 'undefined' ? window.location.search : ''): SessionViewerUrlBootstrap {
  const params = new URLSearchParams(search);
  const out: SessionViewerUrlBootstrap = {};

  const tRaw = params.get('t') ?? params.get('time');
  if (tRaw != null && tRaw !== '') {
    const n = Number(tRaw);
    if (Number.isFinite(n)) out.initialTimeMs = n;
  }

  const tabRaw = params.get('tab');
  if (tabRaw && isTabId(tabRaw)) out.initialTab = tabRaw;

  const selRaw = params.get('sel') ?? params.get('id');
  if (selRaw !== null) out.selectedItemId = selRaw === '' ? null : selRaw;

  if (params.get('focus') === 'error') out.initialFocus = 'error';

  return out;
}
